module.exports = __webpack_public_path__ + "img/TurkishRestaurantLogo.d6bc2101.png";